<template>
	<div class="tw-w-10/12 tw-mx-auto">
		<div class="tw-flex tw-justify-end tw-mb-4">
			<v-btn class="custom-button" color="primary" @click="goTo('job-evaluation-processes')">Atrás</v-btn>
			<v-btn class="custom-button" color="secondary" @click="goTo('job-evaluation-process-disenar-escala')">Siguiente</v-btn>
		</div>
		<greetings-header
			:session-name="sessionName"
			sub-title="Observa la valoración de los puestos"
			class="tw-mb-4"
		/>
		<job-valuation-summary-table
			:job-names="jobNames"
			:appraisers="appraisers"
			:valuations="valuations"
			:avarages="avarages"
			@sendEmailClick="sendEmailClick"
		/>
	</div>
</template>

<script>
import GreetingsHeader from '@/modules/shared/components/business/GreetingsHeader';
import helper from '@/shared/helper';
import JobValuationSummaryTable
	from '@/modules/job-evaluation/components/process/job-valuation/job-valuation-summary-table';

const { getLocalData } = helper;

function created() {
	this.loadJobValuation();
}

async function loadJobValuation() {
	const params = {
		averages: true,
	};
	try {
		const { data: response } = await this.$httpPraktiko.get(
			'groups/JEV', { params });
		const jobOrder = response.jobs.map(j => j.id);
		this.avarages = response.jobs.map(o => o.average);
		this.jobNames = response.jobs.map(p => p.name);
		const stateByEmployee = {};
		response.diagnosticEmployees.forEach((d) => {
			stateByEmployee[d.employeeId] = d.state;
		});
		this.appraisers = response.committeeEmployees.map(emp => ({
			...emp,
			evaluationState: stateByEmployee[emp.id] || 0,
		}));
		this.valuations = response.diagnosticEmployees.map((diagnostic) => {
			const jobsById = {};
			(diagnostic.additionalInformation.jobs || []).forEach((job) => {
				jobsById[job.id] = job;
			});
			return jobOrder.map(id => jobsById[id] || { id, name: '', average: '-' });
		});
	} catch (error) {
		this.showGenericError();
	}
}

async function sendEmailClick(row) {
	try {
		await this.$httpPraktiko.post(`groups/${row.committeeId}/${row.id}/email`);
		this.showNotification('Se reeenvio correctamente');
	} catch (error) {
		this.showGenericError();
	}
}

export default {
	name: 'page-process-job-valuation',
	components: { JobValuationSummaryTable, GreetingsHeader },
	created,
	data() {
		return {
			avarages: [],
			rowsValueations: [],
			jobNames: [],
			appraisers: [],
			valuations: [],
			rows: [],
		};
	},
	computed: {
		sessionName() {
			const { name, lastName } = getLocalData('praktiko-user');
			return `${name} ${lastName}`;
		},
	},
	methods: {
		loadJobValuation,
		sendEmailClick,
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/process/job-valuation/page-process-job-valuation.vue